"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewDeleteLocationResult = exports.RouteInfo = void 0;
const class_validator_1 = require("class-validator");
class RouteInfo {
    _id;
    originLocationMachineName;
    destinationLocationMachineName;
}
exports.RouteInfo = RouteInfo;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RouteInfo.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RouteInfo.prototype, "originLocationMachineName", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RouteInfo.prototype, "destinationLocationMachineName", void 0);
class PreviewDeleteLocationResult {
    canBeDeleted;
    usedByRoutesCount;
    usedByOrdersCount;
    usedByDriversCount;
    usedByDriverCompaniesCount;
    routes;
    orderIds;
    driverIds;
    driverCompanyIds;
}
exports.PreviewDeleteLocationResult = PreviewDeleteLocationResult;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], PreviewDeleteLocationResult.prototype, "canBeDeleted", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PreviewDeleteLocationResult.prototype, "usedByRoutesCount", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PreviewDeleteLocationResult.prototype, "usedByOrdersCount", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PreviewDeleteLocationResult.prototype, "usedByDriversCount", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PreviewDeleteLocationResult.prototype, "usedByDriverCompaniesCount", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], PreviewDeleteLocationResult.prototype, "routes", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], PreviewDeleteLocationResult.prototype, "orderIds", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], PreviewDeleteLocationResult.prototype, "driverIds", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], PreviewDeleteLocationResult.prototype, "driverCompanyIds", void 0);
//# sourceMappingURL=PreviewDeleteLocationResult.js.map